import { pathToRegexp } from 'path-to-regexp';

export default (pathname, path, options?) => pathToRegexp(path, [], options).test(pathname);